import { DefaultApi } from '../../../api';
import { getCatchError } from '../../../getCatchError';
import { urls } from '../../../urls';

const setPostWager = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_CASHIER_WAGER
            });
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setPostWager as SetPostWager
}